define('SageDotCom/Components/ModalWithImageButton',[
        "jquery",
        "score_bootstrap/Components/YoutubeVideo",
        "SageDotCom/DataLayer/Global/youtube-video-tracker",
        "SageDotCom/DataLayer/Global/brightcove-video-tracker"
],
    function ($, Youtube, tracker, BrightcoveVideoTracker) {
        function ModalWithImageButton(scope) {
            var $button = $(".score-image-button", scope);
            var $modal = $(".modal", scope);
            var $youtubeVideo = $modal.find(".score-youtube-video");
            var $brightcoveVideo = getBrightcoveVideo($modal);
            var isIframeBrightcoveVideo = setIsIframeBrightcoveVideo($brightcoveVideo);
            var $carousel = $(".score-carousel");
            var $targetParentModalId;

            var focusableElements;
            var firstElement;
            var lastElement;
            var prevFocusableElement;

            // Add a video class to the main div if a youtube video has been added
            if ($youtubeVideo.length > 0) {
                $button.parent().addClass('video');
            }

            // show the modal once it has been clicked
            setTimeout(function () {
                $button.on("click", function (e) {
                    e.preventDefault();
                    $targetParentModalId = e.target.parentElement.closest(".sage-modal-image-button").id;
                    if ($carousel) {

                        $modal = $modal.detach();
                        $('body').append($modal);
                        $modal.modal("show");
                        $modal.focus();

                        $carousel.carousel("pause");
                    }

                    playYoutubePlayer($youtubeVideo);
                    playBrightcovePlayer($brightcoveVideo, isIframeBrightcoveVideo);
                });

                $(".modal").on("show.bs.modal", function (e) {
                    $modal.attr("aria-hidden", false);
                    focusableElements = Array.from(e.target.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not(.chrome-ui-button):not(#chrome-url-bar)'));
                    prevFocusableElement = document.activeElement;

                    if (focusableElements != null && focusableElements.length > 0) {
                        firstElement = focusableElements[0];
                        lastElement = focusableElements[focusableElements.length - 1];
                    }

                    trapFocus(true, firstElement, lastElement, prevFocusableElement);
                });

                $modal.on("shown.bs.modal", function (e) {
                    if ($brightcoveVideo !== null && $brightcoveVideo !== undefined && $brightcoveVideo.length > 0 && isIframeBrightcoveVideo) {
                        var player = $brightcoveVideo.find("iframe") !== null && $brightcoveVideo.find("iframe") !== undefined ? $brightcoveVideo.find("iframe").get(0) : $brightcoveVideo.find("iframe");
                        if (player && player != null && player != undefined) {
                            var $brightCoveIframe = player.contentWindow;
                            var $brightCoveDomain = player.src;
                            setTimeout(function () {
                                var message = "playerStartTracking";
                                $brightCoveIframe.postMessage(message, $brightCoveDomain);
                                message = "playerTimeTracking";
                                $brightCoveIframe.postMessage(message, $brightCoveDomain);
                            }, 200);
                        }
                    }
                });

                // pause the video if it is closed so it doesn't keep playing
                $modal.on("hidden.bs.modal", function(e) {
                    if ($carousel) $carousel.carousel("cycle");

                    if ($youtubeVideo.length > 0) {
                        pauseYoutubePlayer($youtubeVideo);
                    }
                    if ($brightcoveVideo.length > 0) {
                        pauseBrightcovePlayer($brightcoveVideo, isIframeBrightcoveVideo);
                    }

                    if ($targetParentModalId) {
                        var $targetBtnSelected = $('#' + $targetParentModalId + ' .score-image-button');
                        if ($targetBtnSelected) {
                            $targetBtnSelected.focus();
                        }
                    }
                    trapFocus(false, firstElement, lastElement, prevFocusableElement);
                    $modal.attr("aria-hidden", true);
                });
            }, 250);
        }

        // When dealing with carousel or tabset it can remove the player and then reattach 
        // causing issues with finding the ccf_module.   This is the workaround for it
        // OnReady didn't seem to work so changed the iframe url to include autoplay to force it to work
        function playYoutubePlayer(youtubeVideo) {
            if (youtubeVideo.length > 0) {
                var $youtubeCCFModule = youtubeVideo.data("ccf_module");
                var iframeObj = youtubeVideo.find("iframe").get(0);
                var newSrc = iframeObj.src.replaceAll(":443", "");

                if ($youtubeCCFModule) {
                    iframeObj.src = newSrc;

                    $youtubeCCFModule.player.addEventListener(
                        "onReady",
                        function (ytModule) {
                            ytModule.play();
                        }.bind(this, ytModule)
                    );
                } else {
                    // Set the iframe to autoplay=1 so it will play the video when loaded
                    var currentURL = newSrc;

                    if (currentURL.indexOf("autoplay=") === -1) {
                        //autoplay not present in src; so lets add it
                        if (currentURL.indexOf('?') === -1)
                            currentURL = currentURL + '?autoplay=1'
                        else
                            currentURL = currentURL + '&autoplay=1'
                    }
                    else {
                        if (currentURL.indexOf("autoplay=1") === -1) {
                            //replace autoplay=0 with autoplay=1
                            currentURL = currentURL.replace('autoplay=0', 'autoplay=1');
                            currentURL = currentURL.replace('autoplay=', 'autoplay=1');
                        }
                    }

                    iframeObj.src = currentURL; //set the newer src to iframe
                }

                setTimeout(new tracker().start, 0);
            }
        }

        // When dealing with carousel or tabset it can remove the player and then reattach 
        // causing issues with finding the ccf_module.   This is the workaround for it
        function pauseYoutubePlayer(youtubeVideo)
        {
            if (youtubeVideo.length > 0) {
                var $youtubeCCFModule = youtubeVideo.data("ccf_module");
                if ($youtubeCCFModule) {
                    $youtubeCCFModule.pause();
                } else {
                    var $youtubeIframe = youtubeVideo.find('iframe').get(0).contentWindow;
                    if ($youtubeIframe) {
                        $youtubeIframe.postMessage(
                            JSON.stringify(
                                {
                                    'event': 'command',
                                    'func': 'pauseVideo',
                                    'args': [],
                                    'id': 'test-player'
                                }), "*");
                    }
                }
            } 
        }

        function getBrightcoveVideo($modal) {
            var $brightcoveVideo = $modal.find(".brightcove-media-container-js");
            if ($brightcoveVideo !== null && $brightcoveVideo.length > 0) {
                return $brightcoveVideo.find(".video-js");
            }

            $brightcoveVideo = $modal.find(".brightcove-media-container-iframe");
            if (!($brightcoveVideo)) {
                $brightcoveVideo = $modal.find(".brightcove-media-container");
            }
            return $brightcoveVideo;
        }

        function setIsIframeBrightcoveVideo($brightcoveVideo) {
            if ($brightcoveVideo !== undefined && $brightcoveVideo !== null && $brightcoveVideo.length > 0) {
                return $brightcoveVideo.parents(".brightcove-media-container-js") !== null && $brightcoveVideo.parents(".brightcove-media-container-js").length > 0 ? false : true;
            }
            return null;
        }

        function playBrightcovePlayer(brightcoveVideo, isIframeBrightcoveVideo) {
            if (brightcoveVideo.length > 0) {
                if (!isIframeBrightcoveVideo) {
                    // must be JS video
                    var video = videojs.getPlayer(brightcoveVideo.attr("id"));
                    video.muted(true);
                    video.play();

                }
            }
        }

        function pauseBrightcovePlayer(brightcoveVideo, isIframeBrightcoveVideo) {
            if (brightcoveVideo.length > 0) {
                if (isIframeBrightcoveVideo) {
                    var $brightCoveIframe = brightcoveVideo.find("iframe").get(0);
                    if ($brightCoveIframe.contentWindow) {

                        $brightCoveIframe.contentWindow.postMessage(
                            "pauseVideo", $brightCoveIframe.src
                        );
                    }
                }
                else {
                    // must be JS video
                    var videoId = brightcoveVideo.attr("id");
                    videojs.getPlayer(videoId).pause();
                }
            }
        }

        function trapFocus(isModalOpen, firstElement, lastElement, prevFocusableElement) {
            const handleFocus = e => {

                if (e.keyCode == 9) {
                    if (!e.shiftKey && $(e.target).is(lastElement)) {
                        e.preventDefault();
                        firstElement.focus();
                    } else if (e.shiftKey && $(e.target).is(firstElement)) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                }
            };

            if (isModalOpen) {
                firstElement.focus();
                document.addEventListener("keydown", handleFocus, true);
            }
            else {
                document.removeEventListener("keydown", handleFocus, true);
                prevFocusableElement.focus();
            }
        }

        ModalWithImageButton.init = function init(args) {
            return args.IsEditorEditing === true
                ? null
                : new ModalWithImageButton(args.scope);
        };

        return ModalWithImageButton;
    });

